import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
    Row,
    Col,
    Button,
    Form,
    ListGroup,
    InputGroup,
    Toast
} from 'react-bootstrap';
import 'react-datetime/css/react-datetime.css';
import _ from 'lodash';
import {
    addUsers,
    setError,
    setLoading,
} from '../../store/actions/dashboardAction';
import MultiSelect from 'multiselect-react-dropdown';
import { permissionUsers } from '../../helper/permission';

const HelpPageWrapper = styled.div`
	background-color: #f7f7f7;
	position: relative;
	padding: 2rem 0;
	min-height: auto;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

function AddUser(props) {
    const [passwordNotMatch, setPasswordNotMatch] = useState(false);

    const _passwordInputRef = useRef('');
    const _confirmPasswordInputRef = useRef('');

    const emailRef = useRef(null);
    const firstNameRef = useRef(null);
    const lastNameRef = useRef(null);
    const phoneRef = useRef(null);

    // toast states
    const [toastBgColor, setToastBgColor] = useState('bg-success');
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('Delete successful');
    const [selectedOptions, setSelectedOptions] = useState([]);
    const timeSlot = permissionUsers || [];

    // toast event
    const handleShowToast = (type) => {
        setShowToast(true);

        if (type === 'SUCCESS') {
            setToastBgColor('bg-success');
            setToastMessage('Operation successful.');
        } else if (type === 'ERROR') {
            setToastBgColor('bg-danger');
            setToastMessage('Operation error.');
        }
    };

    const handlePasswordChange = () => {
        if (
            _passwordInputRef.current.value !== _confirmPasswordInputRef.current.value
        ) {
            setPasswordNotMatch(true);
        } else {
            setPasswordNotMatch(false);
        }
    };

    // const [isChecked, setIsChecked] = useState(true)

    const handleAddSupplier = async (event) => {
        try {
            const form = event.currentTarget;

            if (form.checkValidity()) {
                if (passwordNotMatch) {
                    alert('Password and confirm password not match.');
                } else {
                    const dataInput = {
                        is_manager: 0,
                        is_authorised: 1,
                        active: 1,
                        otp: 0,
                        first_name: firstNameRef.current.value,
                        last_name: lastNameRef.current.value,
                        email: emailRef.current.value,
                        password: _passwordInputRef.current.value,
                        phone: phoneRef.current.value,
                        permission: selectedOptions ?? []
                    };

                    props.addUsers(dataInput, setShowToast, setToastMessage, setToastBgColor);
                }
            }
        } catch (error) {
            handleShowToast('ERROR');
            console.log('Debug: ', error);
        }
    };
    
    const handleSelect = (selectedList, selectedItem) => {
        if (selectedOptions.length > 0 && selectedOptions.includes(selectedItem)) {
            const updatedSelectedOptions = selectedOptions.filter(option => option !== selectedItem);
            setSelectedOptions(updatedSelectedOptions);
        } else {
            setSelectedOptions(selectedList);
        }
    };

    const handleRemove = (selectedList, removedItem) => {
        const updatedSelectedOptions = selectedOptions.filter(option => option !== removedItem);
        setSelectedOptions(updatedSelectedOptions);
    }

    console.log("selectedOptions", selectedOptions);

    return (
        <HelpPageWrapper>
            <Row>
                <Col sm={11} className='mb-4'>
                    <h2>Add User</h2>
                </Col>
            </Row>
            <Row>
                <Col sm={11}>
                    <Form autoComplete='false'>
                        <Row>
                            <Col sm={6}>
                                <Form.Group controlId='formName'>
                                    <Form.Label>First Name</Form.Label>
                                    <InputGroup hasvalidation='true'>
                                        <Form.Control
                                            type='text'
                                            ref={firstNameRef}
                                            placeholder='First Name'
                                            required
                                        />
                                    </InputGroup>
                                </Form.Group>
                                <Form.Group controlId='formEmail'>
                                    <Form.Label>Email Login </Form.Label>
                                    <InputGroup hasvalidation='true'>
                                        <Form.Control
                                            type='email'
                                            ref={emailRef}
                                            placeholder='Email address'
                                            required
                                        />
                                    </InputGroup>
                                </Form.Group>
                                <ListGroup className='mb-3'>
                                    <ListGroup.Item>
                                        <Form.Group controlId='formPassword'>
                                            <Form.Label>Password</Form.Label>
                                            <InputGroup hasvalidation='true'>
                                                <Form.Control
                                                    type='password'
                                                    ref={_passwordInputRef}
                                                    autoComplete='off'
                                                    required
                                                    onChange={handlePasswordChange}
                                                    placeholder='Password'
                                                />
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group controlId='formConfirmPassword'>
                                            <Form.Label>Confirm password</Form.Label>
                                            <InputGroup hasvalidation='true'>
                                                <Form.Control
                                                    type='password'
                                                    autoComplete='off'
                                                    ref={_confirmPasswordInputRef}
                                                    onChange={handlePasswordChange}
                                                    required
                                                    placeholder='Confirm password'
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Col>
                            <Col sm={6}>
                                <Form.Group controlId='formName'>
                                    <Form.Label>Last Name</Form.Label>
                                    <InputGroup hasvalidation='true'>
                                        <Form.Control
                                            type='text'
                                            ref={lastNameRef}
                                            placeholder='Last Name'
                                            required
                                        />
                                    </InputGroup>
                                </Form.Group>
                                <Form.Group controlId='formPhone'>
                                    <Form.Label>Phone number</Form.Label>
                                    <InputGroup hasvalidation='true'>
                                        <Form.Control
                                            type='tel'
                                            ref={phoneRef}
                                            placeholder='Phone number'
                                            required
                                        />
                                    </InputGroup>
                                </Form.Group>
                                <Form.Group controlId='formPermission'>
                                    <Form.Label>Permission</Form.Label>
                                        <MultiSelect
                                            options={timeSlot}
                                            selectedValues={selectedOptions}
                                            onSelect={handleSelect}
                                            onRemove={handleRemove}
                                            groupBy='head'
                                            showCheckbox={true}
                                            placeholder="All permissions"
                                            displayValue="label"
                                        />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Col>
                            <Button
                                variant='primary'
                                className='pull-right w-25'
                                onClick={handleAddSupplier}
                            >
                                Add
                            </Button>
                        </Col>
                    </Form>

                    <Toast
                        className={toastBgColor}
                        onClose={() => setShowToast(false)}
                        show={showToast}
                        delay={3000}
                        autohide
                        style={{
                            position: 'fixed',
                            top: 70,
                            right: 35,
                            zIndex: 1041,
                            width: '300px',
                        }}
                    >
                        <Toast.Header>
                            <strong className='mr-auto m-3'>{toastMessage}</strong>
                        </Toast.Header>
                    </Toast>
                </Col>
            </Row>
        </HelpPageWrapper>
    );
}

const mapStateToProps = (state) => {
    return {
        success: state.dashboardReducer.success,
        loading: state.dashboardReducer.loading,
        error_message: state.dashboardReducer.error_message,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addUsers: (data, setShowToast, setToastMessage, setToastBgColor) => addUsers(data, setShowToast, setToastMessage, setToastBgColor, dispatch),
        setError: (data) => setError(data, dispatch),
        setLoading: (data) => setLoading(data, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddUser);
